import { Footer } from './styled';
export function TemplateDrawerFooter(props) {
    const { children } = props;
    return <Footer>{children}</Footer>;
}
